import { connect, useDispatch } from "react-redux";
import { IFacultyMonthlyReports } from "../../../../../models/faculty/facultyReports";
import { useEffect } from "react";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setReportsMonthly } from "../../../../../store/slices/master/reportSlice";
import { getReports } from "../../../../../action/masters/reportActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import { ReportFrequency } from "../../../../../models/dashboard/adminDashboard";

const AllMonthlyFacultyReports = (props: IFacultyMonthlyReports) => {
  const { getMonthlyReports, monthlyReports } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getMonthlyReports(
      pageBlockId.facultyReports,
      undefined,
      ReportFrequency.Monthly
    );
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setReportsMonthly([]));
    };
  }, []);

  return (
    <div className="widgets">
      <div className="title">
        <h2>All Weekly Reports</h2>
      </div>
      <div className="card-wrap">
        <div className="row">
          {monthlyReports?.map((report) => (
            <div className="report-all-card col-lg-12 mb-2" key={report.id}>
              <div className="card">
                <div className="img">
                  <img src={baseURL + report.icon} alt="" />
                </div>
                <div className="desc">
                  <h3>{report.name}</h3>
                  <p>{report.description}</p>
                  <a href={report.url} target="_blank" className="mt-3 btn-arrow btn-block-arrow">
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getMonthlyReports: (
    pageBlockId: number,
    noOfItems: undefined,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, undefined, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    monthlyReports: state.report.monthlyreports,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllMonthlyFacultyReports);
